var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales-signup-page"},[_c('sales-header'),_c('sales-account-signup'),_c('sales-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }